module.exports = __webpack_public_path__ + "static/media/emptypage.1258c96b.jpg";